import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { MissingCmrsClient } from "@/features/missingCmrs/MissingCmrsClient";
import { DEFAULT_PERIOD_DAYS, PERIOD_DAYS, type MissingCmrState, type PeriodDays } from "@/features/missingCmrs/missingCmrs.api";

// Transport → Ontbrekende CMR's (docs/scantafel.md §13): what WLX unloaded whose signed CMR is not in. Reading takes
// tms_orders, as Palletcontrole; ticking *Geen CMR retour* takes tms_orders_write.
export const Route = createFileRoute("/_shell/missing-cmrs")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_orders") && !hasModule(context.session, "tms_orders_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  validateSearch: (search: Record<string, unknown>): { state?: Exclude<MissingCmrState, "missing">; days?: PeriodDays } => ({
    state: (["recent", "no_return"] as const).find((state) => state === search.state),
    days: PERIOD_DAYS.find((days) => days !== DEFAULT_PERIOD_DAYS && String(days) === String(search.days)),
  }),
  component: MissingCmrsScreen,
});

function MissingCmrsScreen() {
  const { state, days } = Route.useSearch();
  const navigate = Route.useNavigate();
  const { session } = Route.useRouteContext();
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Missing CMRs">
      <MissingCmrsClient
        userId={session.userId}
        state={state ?? "missing"}
        days={days ?? DEFAULT_PERIOD_DAYS}
        onState={(next) => navigate({ search: (prev) => ({ ...prev, state: next === "missing" ? undefined : next }), replace: true })}
        onDays={(next) => navigate({ search: (prev) => ({ ...prev, days: next === DEFAULT_PERIOD_DAYS ? undefined : next }), replace: true })}
        canWrite={hasModule(session, "tms_orders_write")}
        canOpenTrips={hasModule(session, "tms_planning") || hasModule(session, "tms_planning_write")}
      />
    </div>
  );
}
